import { Healthcheck } from 'domain/shared/newProject';

export enum ProductionOwnership {
  OUR_TEAM = 'OUR_TEAM',
  CLIENT_SIDE = 'CLIENT_SIDE',
}

export enum DeliveryModel {
  LEAN = 'LEAN',
  STANDARD = 'STANDARD',
  REGULATED = 'REGULATED',
}

export enum Severity {
  LOW = 'LOW',
  MEDIUM = 'MEDIUM',
  HIGH = 'HIGH',
  CRITICAL = 'CRITICAL',
}

export interface EngineeringTrackingPolicy {
  id: string;
  projectId: string;
  productionOwnership: ProductionOwnership;
  deliveryModel?: DeliveryModel | null;
  ppcLink: string;
  ppcLinkUpdatedAt: string;
  updatedAt?: string | null;
  createdAt: string;
}

export interface EngineeringIncidentReport {
  id: string;
  projectId: string;
  shortDescription: string;
  severity: Severity;
  linkToDetails: string | null;
  notes: string;
  updatedAt: string | null;
  createdAt: string;
}

export interface EngineeringBugReport {
  id: string;
  projectId: string;
  shortDescription: string;
  isCritical: boolean;
  linkToDetails: string | null;
  notes: string;
  updatedAt: string | null;
  createdAt: string;
}

export interface ProjectEngineeringGraphqlData {
  id: string;
  health?: {
    id?: string;
    healthChecks?: Healthcheck[];
  } | null;
  engineeringPolicy: EngineeringTrackingPolicy | null;
  engineeringIncidents: EngineeringIncidentReport[];
  engineeringBugs: EngineeringBugReport[];
}

export interface SaveEngineeringConfigurationPayload {
  productionOwnership: ProductionOwnership;
  deliveryModel: DeliveryModel | null;
  ppcLink: string;
}

export interface SaveIncidentPayload {
  id?: string;
  shortDescription: string;
  severity: Severity;
  linkToDetails: string | null;
  notes: string;
}

export interface SaveBugPayload {
  id?: string;
  shortDescription: string;
  isCritical: boolean;
  linkToDetails: string | null;
  notes: string;
}
